import type { LocaleType } from "lib/apollo/types";
import { useAppContext } from "hooks";

export const useLocale = (): LocaleType => {
  const context = useAppContext();
  return context.locale;
};
